import { render, staticRenderFns } from "./p404.vue?vue&type=template&id=f661b332&scoped=true&"
import script from "./p404.vue?vue&type=script&lang=js&"
export * from "./p404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f661b332",
  null
  
)

export default component.exports